import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";

export default function Header() {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <motion.header
      data-testid="header-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled ? "border-b border-white/5 bg-black/60 backdrop-blur-xl" : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-end">
        <div className="flex items-center gap-4 sm:gap-6">
          <div className="flex items-center gap-1 font-mono2 text-xs tracking-widest" data-testid="lang-switcher">
            <button
              data-testid="lang-switch-fr"
              onClick={() => setLang("fr")}
              className={`px-2 py-1 transition-colors duration-300 ${lang === "fr" ? "text-[#CCFF00]" : "text-zinc-400 hover:text-white"}`}
            >
              FR
            </button>
            <span className="text-zinc-600">/</span>
            <button
              data-testid="lang-switch-en"
              onClick={() => setLang("en")}
              className={`px-2 py-1 transition-colors duration-300 ${lang === "en" ? "text-[#CCFF00]" : "text-zinc-400 hover:text-white"}`}
            >
              EN
            </button>
          </div>

          <button
            data-testid="header-cta-button"
            onClick={scrollToForm}
            className="hidden sm:block font-mono2 text-xs tracking-widest uppercase text-white border border-white/15 rounded-sm px-4 py-2 hover:border-[#CCFF00]/60 hover:text-[#CCFF00] transition-colors duration-300"
          >
            {t.nav.cta}
          </button>
        </div>
      </div>
    </motion.header>
  );
}
